<template>
  <div :class="classes">
      <pt-page-title title="脐荐康用户详情"></pt-page-title>
      <div v-loading="detailLoading">
        <div v-if="!isShowRejectOparetion">
      <pt-sub-title title="记录信息"></pt-sub-title>
        <table :class="$style['record-message']">
          <pt-message-table-item label="序号">{{oldAndNewDetail.serialNumber}}</pt-message-table-item>
          <pt-message-table-item label="达标时间">{{oldAndNewDetail.achieve_date}}</pt-message-table-item>
        </table>
      <template v-if="isShowOldMessage">
        <pt-sub-title title="老用户信息"></pt-sub-title>
        <customer-message  contentType="grant" :customer="oldAndNewDetail.oldCustomer" :detail="oldAndNewDetail"  @formValue="formValueOld"  @rejectEdit="rejectEdit"
        :isEditCoupons="isEditOldCoupons"  ref="customerMessageOld" :defualtAmount="oldCustomerDefualtAmount" customerType="OLD"></customer-message>
      </template>
      <!-- <template v-if="isShowNewMessage"> -->
      <pt-sub-title title="新用户信息"></pt-sub-title>
      <customer-message  contentType="grant" :customer="oldAndNewDetail.newCustomer" :detail="oldAndNewDetail" @formValue="formValueNew" @rejectEdit="rejectEdit"
      :isEditCoupons="isEditNewCoupons"  ref="customerMessageNew" :defualtAmount="newCustomerDefualtAmount"  customerType="NEW" :type="type"></customer-message>
      <!-- </template> -->
            <div class="button-div" v-if="isReward">
        <el-button type="primary" @click="submit" :loading="submitLoading">提交</el-button>
        <el-button type="primary" @click="cancel" plain>取消</el-button>
    </div>
        </div>
      <rejected-edit v-if="isShowRejectOparetion" :BringNewAuditDetail="BringNewAuditDetail" :customerType="rejectCustomerType" :id="id"></rejected-edit>
    </div>
  </div>
</template>

<script>
// 组件class前缀
import customerMessage from './customer-message'
import rejectedEdit from './rejected-edit'
import { cashCount } from '@/utils/formUtils'
const prefixCls = 'pt-old-to-new-detail'
export default {
  name: 'pt-old-to-new-detail',
  components: {
    customerMessage,
    rejectedEdit
  },
  computed: {
    classes () {
      return `${prefixCls}`
    },
    // 是否允许编辑老用户优惠劵
    isEditOldCoupons () {
      return this.oldAndNewDetail && (this.oldAndNewDetail.oldCustomer && this.oldAndNewDetail.oldCustomer.rewardStatus === 'NO_REWARD')
    },
    // 是否允许编辑新用户优惠劵
    isEditNewCoupons () {
      return this.oldAndNewDetail && (this.oldAndNewDetail.newCustomer && this.oldAndNewDetail.newCustomer.rewardStatus === 'NO_REWARD')
    },
    // 是否允许发放提交
    isReward () {
      return (this.type === 'ALL' && (this.oldAndNewDetail && ((this.oldAndNewDetail.newCustomer && this.oldAndNewDetail.newCustomer.rewardStatus === 'NO_REWARD') ||
      (this.oldAndNewDetail.oldCustomer && this.oldAndNewDetail.oldCustomer.rewardStatus === 'NO_REWARD')))) || (this.type === 'OLD' && this.isEditOldCoupons) || (this.type === 'NEW' && this.isEditNewCoupons)
    },
    // 是否显示老用户信息
    isShowOldMessage () {
      return this.type === 'ALL' || this.type === 'OLD'
    },
    // 是否显示新用户信息
    isShowNewMessage () {
      return this.type === 'ALL' || this.type === 'NEW'
    },
    fromOld () {
      return this.$refs.customerMessageOld
    },
    fromNew () {
      return this.$refs.customerMessageNew
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    oldAndNewDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    detailLoading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'ALL'
    }
  },
  data () {
    return {
      oldMessage: {},
      newMessage: {},
      oldCustomerDefualtAmount: 100,
      newCustomerDefualtAmount: 500,
      isShowRejectOparetion: false,
      BringNewAuditDetail: {},
      rejectCustomerType: null
    }
  },
  watch: {
    oldAndNewDetail: {
      handler: function (val) {
        if (val.oldCustomer.rewardCount === 1) {
          this.oldCustomerDefualtAmount = 100
        } else {
          this.oldCustomerDefualtAmount = 100
        }
      }
    }
  },
  methods: {
    rejectEdit (val, customerType) {
      this.BringNewAuditDetail = val
      this.rejectCustomerType = customerType
      this.isShowRejectOparetion = true
    },
    formValueOld (val) {
      this.oldMessage = val
    },
    formValueNew (val) {
      this.newMessage = val
    },
    submit () {
      let data = {
        ids: [],
        newDiscountCoupons: null,
        oldDiscountCoupons: null
      }
      data.newMoney = this.newMessage.amount ? cashCount(this.newMessage.amount) : null
      data.oldMoney = this.oldMessage.amount ? cashCount(this.oldMessage.amount) : null
      data.ids.push(this.oldAndNewDetail.id)
      if (this.newMessage.coupon_list && this.newMessage.coupon_list.length > 0) {
        data.newDiscountCoupons = []
        this.newMessage.coupon_list.forEach(item => {
          data.newDiscountCoupons.push({ id: item.id, amount: item.amount })
        })
      }
      if (this.oldMessage.coupon_list && this.oldMessage.coupon_list.length > 0) {
        data.oldDiscountCoupons = []
        this.oldMessage.coupon_list.forEach(item => {
          data.oldDiscountCoupons.push({ id: item.id, amount: item.amount })
        })
      }
      this.$emit('submit', data)
    },
    cancel () {
      history.go(-1)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.record-message{
  padding: 0 20px;
}
</style>
